module.exports = __webpack_public_path__ + "static/media/Driver Trainings DEC.6091b18b.csv";